module.exports = __webpack_public_path__ + "img/848.98cfae8e.png";